import "@mantine/core/styles.css"

import { Center, createTheme, Loader, MantineProvider, virtualColor } from "@mantine/core"
import { StrictMode, Suspense } from "react"
import { createRoot } from "react-dom/client"
import { createBrowserRouter, RouterProvider } from "react-router"
import { Home } from "./Pages/Home"

import App from "./App.tsx"
import E404 from "./Pages/E404"

import "./i18n/config"
import "./main.css"

const theme = createTheme({
  defaultRadius: "md",
  autoContrast: true,
  luminanceThreshold: 0.4,
  primaryShade: {
    light: 5,
    dark: 6
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.80rem",
    md: "0.95rem",
    lg: "1.25rem",
    xl: "1.5rem"
  },
  lineHeights: {
    xs: "1.2",
    sm: "1.3",
    md: "1.4",
    lg: "1.5",
    xl: "1.6"
  },
  colors: {
    dark: [
      "#f4f4f5", // 0 - Primary text on darkest backgrounds
      "#e4e4e7", // 1 - Secondary text, lighter UI elements
      "#d4d4d8", // 2 - Tertiary text, placeholders, muted labels
      "#52525c", // 3 - Quaternary text, disabled state
      "#3f3f46", // 4 - Divider lines, subtle borders
      "#27272a", // 5 - Hover states, active elements
      "#2a2a2f", // 6 - Elevated surfaces, cards, menu
      "#1a1a1e", // 7 - Primary background
      "#09090b", // 8 - App shell background
      "#000000" // 9 - True black or deepest background
    ],
    primary: virtualColor({
      name: "primary",
      dark: "lime",
      light: "blue"
    })
  }
})

const router = createBrowserRouter(
  [
    {
      element: <App />,
      errorElement: <E404 />,
      children: [{ path: "/", element: <Home /> }]
    }
  ],
  { basename: import.meta.env.BASE_URL || "/" }
)

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <Suspense fallback={<Splash />}>
        <RouterProvider router={router} />
      </Suspense>
    </MantineProvider>
  </StrictMode>
)

export function Splash() {
  return (
    <Center h="100vh">
      <Loader color={"primary"} type={"bars"} />
    </Center>
  )
}
